export default __webpack_public_path__ + "static/media/9.424e93ff.png";